import { render } from "./CoBrandGilt.vue?vue&type=template&id=0e594830&scoped=true"
import script from "./CoBrandGilt.vue?vue&type=script&lang=js"
export * from "./CoBrandGilt.vue?vue&type=script&lang=js"

import "./CoBrandGilt.vue?vue&type=style&index=0&id=0e594830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e594830"]])

export default __exports__